module.exports = __webpack_public_path__ + "static/media/testing_chai.9872d3f5.png";